import React from 'react';
import PropTypes from 'prop-types';
import { Paper, List, Subheader, Toggle } from 'material-ui';
import style from '../../../styles/styles';
import styles from './GamificationSetting.css';
import Loading from '../../common/Loading/Loading';
import withTranslation from '../../../hoc/withTranslation';

class GamificationSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func,
    };

    static defaultProps = {
        app: null,
        loading: false,
    };

    handleToggledSearchInDescription = (event, isInputChecked) => {
        this.props.editConfiguration('quiz_answer_need_to_be_correct', isInputChecked);
    };
    render() {
        const {
            loading,
            app
        } = this.props;
        let content;
        if (loading) {
            content = <Loading paper={false} />;
        } else {
            content = <div>
                <Toggle
                    style={styles.toggle}
                    label={this.props.t('settings_page.quiz_answer_need_to_be_correct')}
                    toggled={app.configurations.quiz_answer_need_to_be_correct}
                    labelPosition="right"
                    onToggle={this.handleToggledSearchInDescription}
                />
                <span style={styles.helperText}>
                    {this.props.t('settings_page.quiz_answer_need_to_be_correct_helper_text')}
                </span>
            </div>;
        }
        return <Paper>
            <List>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('module.gamification.name')}
                </Subheader>

                <div style={style.paper}>
                    {content}
                </div>
            </List>
        </Paper>;
    }
}

export default withTranslation(GamificationSetting);



// WEBPACK FOOTER //
// src/components/common/GamificationSetting/GamificationSetting.js